import { Component, h } from "@lukekaalim/act";
import { html } from "@lukekaalim/act-web";
import { Logic, MiniTemplate, MiniTemplateID } from "../../../defs";
import { TheatreSceneResources, TheatreState } from "../../../hooks";

import classes from './Mini.module.css';
import contentClasses from './index.module.css';
import { MiniModelPreview } from "../../Theatre/Mini/Preview";
import { Graphics3DSetup } from "@kosmod/graphics-3d";
import { TheatreContentManager } from "../../../hooks/useTheatreContentManager";

export type MiniTemplateListProps = {
  miniTemplates: MiniTemplate[],

  resources: TheatreSceneResources,
  content: TheatreContentManager,
  graphicsSetup: Graphics3DSetup,

  selected: MiniTemplateID | null,

  onClick(event: MouseEvent, miniTemplate: MiniTemplate): void,
  onDragStart(event: DragEvent, miniTemplate: MiniTemplate): void
}

export const MiniTemplateList: Component<MiniTemplateListProps> = ({
  miniTemplates, resources, selected, onClick, onDragStart,
  content, graphicsSetup,
  children
}) => {
  return h(html.ol, { className: contentClasses.squareRowList },
    [
     ... miniTemplates.map(miniTemplate => {
        return h(html.li, {
          className: contentClasses.squareRowListItem,
          draggable: true,
          style: { border: selected === miniTemplate.id ? '2px solid black' : '1px solid black' },

          onClick(e) { onClick(e, miniTemplate) },
          onDragStart(e) { onDragStart(e, miniTemplate) },
        }, h(MiniTemplateIcon, { miniTemplate, resources, content, graphicsSetup }))
      }),
    // h(html.li, { className: classes.miniTemplateEntry }, children)
  ])
};

export type MiniTemplateIconProps = {
  miniTemplate: MiniTemplate,

  content: TheatreContentManager,

  graphicsSetup: Graphics3DSetup,
  resources: TheatreSceneResources,
}

export const MiniTemplateIcon: Component<MiniTemplateIconProps> = ({ miniTemplate, resources, content, graphicsSetup }) => {
  const graphics = Logic.find('render', miniTemplate.logic);

  if (!graphics)
    return '?';

  if (graphics.data.renderType === 'model') {
    if (!graphics.data.modelId)
      return '?';

    return h(MiniModelPreview, {
      miniModel: content.miniModels.get(graphics.data.modelId) || null,
      graphics: graphicsSetup,
      resources,
    })
  }
  if (graphics.data.renderType === 'quick-sprite' && graphics.data.spriteId) {
    const url = resources.miniSpritesURLs.get(graphics.data.spriteId);
    if (url)
      return h(html.img, { src: url.href, className: classes.miniTemplateSprite })
  }

  return '?'
}